var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('TopNav'),_c('keep-alive',{attrs:{"exclude":"NewsDetail,News,ProductDetail"}},[_c('router-view')],1),_c('Footer'),_c('AsideTool')],1)}
var staticRenderFns = []

export { render, staticRenderFns }